import { BCMSRecord, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultEdit, getWorkflowSteps } from "compid/workflows/EditPaymentWorkflow";
import { Bill, Biller, Payment } from "model";

import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function CancelPaymentModal
 * @returns {React.Component}
 * @description The modal for the cancel payment workflow
 */
export default function CancelPaymentModal(props) {
    // Initalize the workflow step and get the step state
    const workflowStep = useWorkflowStep(getDefaultEdit, getWorkflowSteps);
    const { payment, bill } = workflowStep.getStepState;
    const data = props.data ?? {};
    var modalDataPayment = undefined;
    var modalDataBill = undefined;
    const openedModalFromPage = data.openedModalFromPage === "scheduledPayment";
    // This modal can now exist in multiple pages/workflows.
    // Previously, this modal was only used in a single workflow.
    if(openedModalFromPage) {
        modalDataPayment = Payment.initByID(props.data.paymentID);
        modalDataBill = Bill.getBillByBiller(payment.to.id);
    }

    const _payment = openedModalFromPage ? modalDataPayment : payment;

    // Set the amount, account and date variables
    const amount = _payment.amount ? _payment.amount.format() : "[$XX.XX]";
    const account = _payment.to ? _payment.to : Biller.firstInstanceOf();
    const date = _payment.date ? _payment.date.format("M d, Y") : "[M D, Y]";
    // cancelPayment :: Remove the payment and update the corresponding bill in model
    const cancelPayment = evt => {
        // If the bill has the same payment set, remove it and update the status
        if(bill.payment instanceof Payment && bill.payment.id === _payment.id) {
            workflowStep.update(["bill", "status"], "Canceled");
            workflowStep.update(["payment", "status"], "canceled");
            workflowStep.update(["bill", "payment"], undefined);
        }

        if(openedModalFromPage) {
            modalDataBill.status = "Canceled";
            _payment.status = "canceled";
        } 

        // Update the model
        BCMSRecord.batch([
            Payment.update(_payment),
            Bill.update(openedModalFromPage ? modalDataBill : bill)
        ], workflowStep.globalController);

        // Navigate to the activity page and pass state
        workflowStep.navigate("/activity", { "state" : { "payment" : _payment.record, "canceled" : true } });
    };

    return (
        <CustomModal id="CancelPaymentModal" title="" className="cancel-payment-modal">
            <CustomModalContent className="flex-container flex-horizontal">
                <SVGAsset id="AlertTriangleIcon" className="icon set-width" />
                <div className="flex-container flex-width flex-vertical">
                    <h2 className="">
                        <b>Cancel Payment</b>
                    </h2>

                    <p className="">
                        Are you sure you want to cancel your { amount } payment to { `${ account.name } ${ account.number }` } scheduled for { _payment.formatDate }?
                    </p>
                </div>
            </CustomModalContent>

            <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal">
                <ModalCloseButton text="Keep payment" id="CancelPaymentModal" />
                <ModalPrimaryButton text="Cancel payment" onClick={ cancelPayment } />
            </CustomModalFooter>
        </CustomModal>
    );
}